import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { formatAmount } from '../../utility/certificationBuilder'

import classes from './PricesList.module.scss'

const PricesList = ({ certification }) => {
  const { t } = useTranslation()

  const priceLabel = (price) => price.organization ? price.organization.name : t('certificationBuilder.prices.default')

  return (
    <div>
      <div className='d-flex align-items-baseline justify-content-between mb-2'>
        <span className={classes.label}>{t('certificationBuilder.prices.title')}</span>
        <span className={classes.managed}>{t('certificationBuilder.prices.managed')}</span>
      </div>

      {certification.prices.length === 0 && <p className={classes.empty}>{t('certificationBuilder.prices.empty')}</p>}

      <div className='d-flex flex-column'>
        {certification.prices.map(price => (
          <div key={price.id} className={classNames('d-flex align-items-center', classes.row)}>
            <span
              className={classNames(
                'd-inline-flex align-items-center justify-content-center', classes.icon, { [classes.iconDefault]: !price.organization }
              )}
            >
              <i className={price.organization ? 'fa fa-users' : 'fa fa-globe'} aria-hidden='true' />
            </span>
            <span className={classNames('flex-grow-1', classes.name)}>
              {priceLabel(price)}
              {!price.organization && <span className={classes.note}> · {t('certificationBuilder.prices.defaultNote')}</span>}
            </span>
            <span
              className={classNames(classes.link, price.chargebeeItemPriceId ? classes.linked : classes.unlinked)}
              title={price.chargebeeItemPriceId && t('certificationBuilder.prices.chargebeeId', { id: price.chargebeeItemPriceId })}
            >
              <i className={price.chargebeeItemPriceId ? 'fa fa-link' : 'fa fa-chain-broken'} aria-hidden='true' />
              {t(price.chargebeeItemPriceId ? 'certificationBuilder.prices.linked' : 'certificationBuilder.prices.notLinked')}
            </span>
            <span className={classes.amount}>{formatAmount(price)}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

PricesList.propTypes = {
  certification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    prices: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      amount: PropTypes.string.isRequired,
      chargebeeItemPriceId: PropTypes.string,
      currency: PropTypes.shape({ code: PropTypes.string.isRequired, symbol: PropTypes.string.isRequired }).isRequired,
      organization: PropTypes.shape({ name: PropTypes.string.isRequired }),
    })).isRequired,
  }).isRequired,
}

export default PricesList
